import React from 'react';
import VerifyBanner from '@/page-components/verify/Banner';
import VerifyQuery from '@/page-components/verify/Query';
import styles from '@/styles/pages/Verify.module.less';

const Verify: React.FC = () => {
  return (
    <div className={styles.verify_page}>
      <VerifyBanner />
      <VerifyQuery />
    </div>
  );
};
export default Verify;
